interface Option {
  shop_id: string;
  main_domain: string;
}

export const convertToWebUrlFromDeeplink = (deeplink: string, option?: Option): string => {
  try {
    const deeplinkStatus = switchDeepLinkStatus(deeplink);
    switch (deeplinkStatus) {
      case 'simple_browser':
      case 'full_screen_simple_browser':
        return convertToPathFromUrlParams(deeplink);
      case 'zigzin_saved_shop_items':
        return convertZigzinSavedShopItemsDeeplink(deeplink, option);
      case 'store_home':
        return convertStoreHomeDeeplink(deeplink, option);
      case 'zigzag':
      default:
        return deeplink;
    }
  } catch (e) {
    return deeplink;
  }
};

const switchDeepLinkStatus = (deeplink: string) => {
  if (/^zigzag:\/\/(open\/)?(\/)?simple_browser\?/.test(deeplink)) {
    return 'simple_browser';
  }
  if (/^zigzag:\/\/(open\/)?(\/)?full_screen_simple_browser\?/.test(deeplink)) {
    return 'full_screen_simple_browser';
  }
  if (/^zigzag:\/\/(open\/)?(\/)?zigzin_saved_shop_items\?/.test(deeplink)) {
    return 'zigzin_saved_shop_items';
  }
  if (/^zigzag:\/\/(open\/)?(\/)?store_home\?/.test(deeplink)) {
    return 'store_home';
  }
  if (deeplink.startsWith('zigzag:')) {
    return 'zigzag';
  }
};

/**
 * @param deeplink 'zigzag:///simple_browser?features=ct&url=https://store.zigzag.kr/crealfit/collection/174'
 * @returns '/crealfit/collection/174'
 */
const convertToPathFromUrlParams = (deeplink: string): string => {
  const urlParams = new URLSearchParams(deeplink.split('?')[1]);
  const webUrlQueryParams = deeplink.split('?')[2];

  const urlValue = urlParams.get('url');
  if (urlValue) {
    const url = convertToCurrentUrl(urlValue);
    if (webUrlQueryParams) {
      return url.includes('?') ? `${url}&${webUrlQueryParams}` : `${url}?${webUrlQueryParams}`;
    }
    return url;
  }
  return deeplink;
};

/**
 * @param url 'https://store.zigzag.kr/crealfit/collection/174'
 * @returns '/crealfit/collection/174'
 */
const convertToCurrentUrl = (url: string): string => {
  const decodedUrl = decodeURIComponent(url);
  const urlRecord = new URL(decodedUrl);
  return urlRecord.pathname + urlRecord.search;
};

/**
 * @param deeplink 'zigzag:///zigzin_saved_shop_items?title=슬로우앤드&shop_id=2833'
 * @returns '/slowand/zigzin-shipping'
 */
const convertZigzinSavedShopItemsDeeplink = (deeplink: string, option?: Option): string => {
  if (!option) {
    return deeplink;
  }
  return `/${option.main_domain}/zigzin-shipping`;
};

/**
 * @param deeplink 'zigzag:///store_home?shop_id=2546&category_id=0'
 * @returns '/slowand/category/0'
 * @description 스토어홈 딥링크를 웹 링크로 변환합니다. category_id가 있는 경우 스토어홈 카테고리 링크로 변환합니다.
 */
const convertStoreHomeDeeplink = (deeplink: string, option?: Option): string => {
  if (!option) {
    return deeplink;
  }
  const applinkSearchParams = new URLSearchParams(deeplink.split('?')[1]);
  const categoryId = applinkSearchParams.get('category_id');
  if (categoryId !== null) {
    return `/${option.main_domain}/category/${categoryId}`;
  }
  return `/${option.main_domain}`;
};
